import Wait from "./Wait.js";
import { getAirportOpenTime, SCHEDULE_TYPES } from "../../assets/virtual-flyout/airport-service.js";

export default class WaitAirportOpen extends Wait {
    constructor(planeId, airport) {
        super(planeId, null, 'AD open');
        this.airport = airport;
    }

    execute() {
        const simState = this.getSimState();
        const airportOpenTime = getAirportOpenTime(this.airport.code, SCHEDULE_TYPES.AD, simState.time);
        this.time = airportOpenTime;

        super.execute();
    }
    
}